import React, { useState } from "react";
import { doc, deleteDoc } from "firebase/firestore";
import { db } from "../../firebase/firebase-config";

interface Assessment {
    id: string;
    date: string;
    time: string;
    painLevel: string;
    pharmacologicalIntervention:{}
    nonPharmacologicalIntervention: string;
    syariahIntervention: string;
    nurseName: string;
    tanggalKajiUlang: string;
}

interface AssessmentVisitHistoryProps {
    assessments: Assessment[];
}

const AssessmentVisitHistory: React.FC<AssessmentVisitHistoryProps> = ({ assessments }) => {
    const [selectedAssessment, setSelectedAssessment] = useState<Assessment | null>(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [modalType, setModalType] = useState<"detail" | "edit" | "delete" | "">("");

    const openModal = (assessment: Assessment, type: "detail" | "edit" | "delete") => {
        setSelectedAssessment(assessment);
        setModalType(type);
        setIsModalOpen(true);
    };

    const handleDelete = async (id: string) => {
        try {
            await deleteDoc(doc(db, "intervention_records", id));
            alert("Assessment berhasil dihapus!");
            setIsModalOpen(false);
        } catch (error) {
            console.error("Error deleting document: ", error);
        }
    };

    return (
        <div className="overflow-x-auto">
            <table className="min-w-full border-collapse border border-gray-300">
                <thead>
                <tr className="bg-gray-100 text-center">
                    <th rowSpan={2} className="border border-gray-300 px-4 py-2">Tanggal</th>
                    <th rowSpan={2} className="border border-gray-300 px-4 py-2">Jam</th>
                    <th colSpan={3} className="border border-gray-300 px-4 py-2">Nyeri</th>
                    <th colSpan={4} className="border border-gray-300 px-4 py-2">Intervensi Farmakologi</th>
                    <th rowSpan={2} className="border border-gray-300 px-4 py-2">Intervensi Non Farmakologi</th>
                    <th rowSpan={2} className="border border-gray-300 px-4 py-2">Intervensi Syariah</th>
                    <th rowSpan={2} className="border border-gray-300 px-4 py-2">Perawat/Bidan</th>
                    <th rowSpan={2} className="border border-gray-300 px-4 py-2">Waktu Kaji Ulang</th>
                    <th rowSpan={2} className="border border-gray-300 px-4 py-2">Aksi</th>
                </tr>
                <tr className="bg-gray-100 text-center">
                    <th className="border border-gray-300 px-4 py-2">Ya</th>
                    <th className="border border-gray-300 px-4 py-2">Tidak</th>
                    <th className="border border-gray-300 px-4 py-2">Skala</th>
                    <th className="border border-gray-300 px-4 py-2">Ya</th>
                    <th className="border border-gray-300 px-4 py-2">Tidak</th>
                    <th className="border border-gray-300 px-4 py-2">Jam Tindakan</th>
                    <th className="border border-gray-300 px-4 py-2">Tindakan</th>
                </tr>
                </thead>
                <tbody>
                {assessments.length > 0 ? (
                    assessments.map((assessment) => (
                        <tr key={assessment.id} className="text-center">
                            <td className="border border-gray-300 px-4 py-2">{assessment.date}</td>
                            <td className="border border-gray-300 px-4 py-2">{assessment.time}</td>

                            {/* Nyeri */}
                            <td className="border border-gray-300 px-4 py-2">{assessment.hasPain === "yes" ? "√" : ""}</td>
                            <td className="border border-gray-300 px-4 py-2">{assessment.hasPain === "no" ? "√" : ""}</td>

                            <td className="border border-gray-300 px-4 py-2">{assessment.painLevel}</td>

                            {/* Intervensi Farmakologi */}
                            <td className="border border-gray-300 px-4 py-2">{assessment.hasPharmacologicalIntervention === "yes" ? "√" : ""}</td>
                            <td className="border border-gray-300 px-4 py-2">{assessment.hasPharmacologicalIntervention === "no" ? "√" : ""}</td>

                            <td className="border border-gray-300 px-4 py-2">
                                {assessment.pharmacologicalIntervention.length > 0 ? assessment.pharmacologicalIntervention[0].time : "-"}
                            </td>
                            <td className="border border-gray-300 px-4 py-2">
                                {assessment.pharmacologicalIntervention.length > 0 ? assessment.pharmacologicalIntervention[0].action : "-"}
                            </td>
                            <td className="border border-gray-300 px-4 py-2">{assessment.nonPharmacologicalIntervention}</td>
                            <td className="border border-gray-300 px-4 py-2">{assessment.syariahIntervention}</td>
                            <td className="border border-gray-300 px-4 py-2">{assessment.nurseName ?? "-Nurse Name-"}</td>
                            {/*<td className="border border-gray-300 px-4 py-2">Andy</td>*/}
                            <td className="border border-gray-300 px-4 py-2">{assessment.tanggalKajiUlang}</td>
                            <td className="border border-gray-300 px-4 py-2">
                                <button onClick={() => openModal(assessment, "delete")} className="bg-red-500 text-white px-2 py-1 rounded">Hapus</button>
                            </td>
                        </tr>
                    ))
                ) : (
                    <tr>
                        <td colSpan={13} className="border border-gray-300 px-4 py-2 text-center">
                            No assessments recorded
                        </td>
                    </tr>
                )}
                </tbody>
            </table>

            {isModalOpen && selectedAssessment && (
                <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
                    <div className="bg-white p-6 rounded-lg shadow-lg w-96">

                        {modalType === "delete" && (
                            <>
                                <h2 className="text-lg font-semibold mb-4">Hapus Assessment</h2>
                                <p>Apakah Anda yakin ingin menghapus data ini?</p>
                                <button onClick={() => handleDelete(selectedAssessment.id)} className="mt-4 bg-red-500 text-white px-4 py-2 rounded">Hapus</button>
                                <button onClick={() => setIsModalOpen(false)} className="mt-4 bg-gray-500 text-white px-4 py-2 rounded ml-2">Batal</button>
                            </>
                        )}
                    </div>
                </div>
            )}
        </div>
    );
};

export default AssessmentVisitHistory;
